<template>
    <div v-if="fieldsValueRange">
        <jt-data-table :api-mode="false" ref="jtDataTableValueRange" :fields="fieldsValueRange.columns" :data="[dataValueRange]">
            <template #header>
                <q-tr class="table-header">
                <q-td v-for="col in fieldsValueRange.columns" :key="col.name">
                    <span v-if="col.name != 'contractItemBillings_quantity'">{{ col.label }}</span>
                </q-td>
                <q-td>
                    {{ $gettext("ACTIONS") }}
                </q-td>
                </q-tr>
            </template>
            <template #body>
                <q-tr :key="indexData" v-for="(rowData, indexData) in filteredValueRange">
                <q-td :key="index" v-for="(colum, index) in fieldsValueRange.columns">
                    <span v-if="colum.field !== 'status' && colum.field !== 'contractItemBillings_value' && colum.field !== 'contractItemBillings_quantity'" class="ellipsis">
                      {{ rowData[colum.field] }}
                    </span>
                    <span v-if="colum.field === 'contractItemBillings_value'" class="ellipsis">
                      {{ rowData[colum.field] }}
                      <q-tooltip
                          anchor="bottom middle"
                          self="top middle"
                          content-style="font-size: 13px"
                          :offset="[5, 5]"
                      >
                          <div>
                          <div class="tooltip-range-area" :key="index" v-for="(itemBilling, index) in getBillings(rowData['id'])">
                              <span class="tooltip-range-item">{{ getQuantityMessage(itemBilling.quantity) }}</span>
                              <span class="tooltip-range-item">{{ getPriceMessage(itemBilling.value) }}</span>
                              <span v-if="!!itemBilling.contractItemBillingType"  class="tooltip-range-item">{{ getContractItemBillingTypeMessage(itemBilling.contractItemBillingType) }}</span>
                          </div>
                          </div>
                      </q-tooltip>
                    </span>
                    <span v-if="colum.field === 'status'">
                      <q-icon v-if="rowData[colum.field] === 'true'" name="check_circle" color="green" size="1.3rem"> </q-icon>
                      <q-icon v-else name="report_problem" color="red" size="1.3rem"> </q-icon>
                    </span>
                </q-td>
                <q-td style="width: 1px" v-if="datatable.buttons">
                    <span v-for="(button, indexButton) in datatable.buttons" :key="indexButton">
                    <q-btn
                        flat
                        small
                        class="protocol-close"
                        color="primary"
                        @click="actionButton(button, rowData['id'])"
                    >
                        <q-icon :name="button.nmIcon" size="22px" />
                        <q-tooltip>{{ button.label }}</q-tooltip>
                    </q-btn>
                    </span>
                </q-td>
                </q-tr>
            </template>
        </jt-data-table>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDocs } from 'jtech-webcomps'
import { repository } from 'jtech'

@Component({
  name: 'ContractItemBillingDataTable',
  mixins: [JtDataTable],
  components: { jtDocsViewer: JtDocs.JtDocsViewer },
  props: {
    contractServiceId: {
      type: Number,
      default: () => { return null }
    },
    datatable: {
      type: Object,
      default: () => { return {} }
    }
  }
})
class ContractItemBillingDataTable extends Vue {
    fieldsValueRange = null
    dataValueRange = []
    filteredValueRange = []
    CONTRACT_SERVICE_INTERFACE = 'contractItem.pesquisarByContractServiceId'

    mounted () {
      this.getValueRangeData()
    }

    getQuantityMessage (quantity) {
      return this.$gettext('FROM') + ' ' + quantity
    }

    getPriceMessage (value) {
      return this.$gettext('CONSIDER') + ' ' + this.$gettext('CURRENCY') + ' ' + value
    }

    getContractItemBillingTypeMessage (contractItemBillingType) {
      return this.$gettext('TYPE') + ' ' + this.$gettext(`CONTRACT_ITEM_BILLING_TYPE.${contractItemBillingType}`)
    }

    filterValueRange () {
      this.dataValueRange.registros.forEach(data => {
        if (!this.filteredValueRange.some(valueRangeItem => valueRangeItem.id === data.id)) {
          this.filteredValueRange.push({ ...data })
        }
      })
      this.filteredValueRange.forEach(filteredValueRange => {
        const groupById = this.dataValueRange.registros.filter(data => data.id === filteredValueRange.id)
        let texto = ''
        groupById.forEach(byIdValueRange => {
          texto += this.$gettext('CURRENCY') + ' ' + byIdValueRange.contractItemBillings_value + '; '
        })
        filteredValueRange.contractItemBillings_value = texto
      })
      this.$forceUpdate()
    }

    async getValueRangeData () {
      const param = { contractServiceId: this.contractServiceId }
      this.dataValueRange = await repository.resolveDatatableModel(this.CONTRACT_SERVICE_INTERFACE, param)
      this.fieldsValueRange = await repository.resolveDatatable(this.CONTRACT_SERVICE_INTERFACE, param)
      this.filterValueRange()
    }

    async actionButton (button, idItem) {
      const params = {
        id: idItem
      }
      this.$emit('actionButton', button, params)
    }

    getBillings (idItem) {
      const itemBillings = []
      const groupById = this.dataValueRange.registros.filter(data => data.id === idItem)
      groupById.forEach(byIdValueRange => {
        itemBillings.push({
          quantity: byIdValueRange.contractItemBillings_quantity,
          value: byIdValueRange.contractItemBillings_value,
          contractItemBillingType: byIdValueRange.contractItemBillingType
        })
      })
      return itemBillings
    }
}
export default ContractItemBillingDataTable
</script>
<style lang="stylus" scoped>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 130px;
}
.tooltip-range-area {
  display: flex;
}
.tooltip-range-item {
  background: black;
  padding: 5px;
  border-radius: 5px;
  margin-left: 5px;
}
</style>
